import React from 'react';
import {
    Banner,
    Stack,
    Button,
    Popover,
    ActionList
} from '@shopify/polaris';
import TagActionComponent from '../TagActionComponent';
import ProductConditionItem from '../ProductConditionItem';

class ResourceTagActionsPaneComponent extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            active: false
        }
    }

    toggleActive = () => {
        this.setState({ "active": !this.state.active });
    }

    onActionSelected = () => {
        this.setState({ "active": false });
    }

    render() {

        let hasActions = this.props.tagActions.length > 0;
        const actionItems = this.props.tagActions.map((item, index) => {
            return <ProductConditionItem
                number={index + 1}
                error={item.error}
                onDelete={() => this.props.onDeleteTagAction(index)}>
                <TagActionComponent
                    action={item}
                    tags={this.props.tags}
                    onActionUpdated={this.props.onUpdateTagAction}
                /></ProductConditionItem>
        });
        const activator = <Button onClick={this.toggleActive} disclosure>Create Tag Action</Button>;
        const sections = [
            {
                "title": "Default",
                items: [
                    {
                        content: "Add Tag",
                        helpText: "Adds new tag by specifying its name",
                        onAction: () => { this.props.onCreateTagAction("add") }
                    },
                    {
                        content: "Add tag conditionally",
                        helpText: "Adds new tag when other tags exist.",
                        onAction: () => { this.props.onCreateTagAction("conditionalAdd") }
                    },
                    {
                        content: "Change prefix",
                        helpText: "Change tag prefix",
                        onAction: () => { this.props.onCreateTagAction("changePrefix") }
                    },
                    {
                        content: "Remove Tag",
                        helpText: "Remove tag by name or condition",
                        onAction: () => { this.props.onCreateTagAction("remove") }
                    },
                    {
                        content: "Rename Tag",
                        helpText: "Change tag names based on conditions",
                        onAction: () => { this.props.onCreateTagAction("rename") }
                    }
                ]
            }
        ]

        return (
            <div>
                {hasActions &&
                    <Stack vertical spacing="none">
                        {actionItems}
                    </Stack>
                }
                {!hasActions &&
                    <Banner status="critical">
                        <p>At least one tag action must be defined.</p>
                    </Banner>
                }
                <br />
                <Popover
                    active={this.state.active}
                    activator={activator}
                    preferredAlignment="left" preferredPosition="mostSpace"
                    onClose={this.toggleActive}>
                    <ActionList sections={sections} onActionAnyItem={this.onActionSelected} />
                </Popover>
            </div>
        );
    }

    componentDidMount() {
    }
}

ResourceTagActionsPaneComponent.defaultProps = {
}

export default ResourceTagActionsPaneComponent;